import { Injectable } from '@angular/core';
import { Base } from "./base";
import {
    Statement as T,
} from '../Interfaces';
import {
    InvestorFile,
} from './investor-file';

@Injectable()
export class Statement extends Base {
    id: number;
    url: string;
    investor_id: number;
    monthly_cut_id: number;
    sent_date: Date | string;
    constructor(json?: T) {
        super(json);
    }
    toString(): string {
        return '';
    }
    toInvestorFile(): InvestorFile {
        let file = new InvestorFile(this);
        file.data = this.url;
        file.extension = 'pdf';
        return file;
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/_models/Classes/statement.ts